/*
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

import { corpulsOrange, corpulsBlue, corpulsGreen, corpulsYellow } from './CorpulsColors';
import { ThemeOptions } from '@mui/material';

const corpulsTheme: ThemeOptions = {
  palette: {
    primary: corpulsOrange,
    warning: corpulsYellow,
    secondary: corpulsGreen,
    info: corpulsBlue,
    success: corpulsGreen,
  },
  components: {
    MuiButtonGroup: {
      defaultProps: {
        disableElevation: true,
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          textTransform: 'initial',
        },
      },
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            color: '#fff',
            backgroundColor: '#fb7324',
            '&:hover': {
              backgroundColor: '#fa601b',
            },
          },
        },
      },
    },
  },

  typography: {
    h1: {
      fontSize: '20px',
      fontWeight: 500,
    },
    h2: {
      fontSize: '15px',
      fontWeight: 700,
    },
    subtitle1: {
      fontSize: '10px',
      fontWeight: 400,
      textAlign: 'left',
    },
    subtitle2: {
      fontSize: '10px',
      fontWeight: 400,
      textAlign: 'left',
      color: 'rgba(0,0,0, 0.6)',
      marginTop: '-10px',
      marginBottom: '10px',
    },
  },
};

export default corpulsTheme;
